import React from 'react';
import {func} from 'prop-types';
import CheckBoxLeftIcon from '../icons/CheckboxLeftIcon';

export default class CheckBox extends React.Component {

    state = {
        checked: this.props.checked,
    };


    static defaultProps = {
        checked: false,
    }

    static propTypes = {
        onCheck: func.isRequired,
    }

    constructor(props) {
        super(props);
    }

    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            checked: Boolean(props.checked),
        }
    }


    shouldComponentUpdate = (nextProps, nextState) => {
        return nextState.checked !== this.state.checked ||
        nextProps.checked !== this.props.checked;
    }

    onCheck = (e) => {
        const checked = e.target.checked;
        this.setState({ checked });
        this.props.onCheck(e, checked);
    }


    render() {
        const {
            label,
            name,
            labelTheme,
            children,
        } = this.props;

        const {
            checked
        } = this.state;

        let indicator = '';
        if (checked) {
            indicator = (
                <div className='b-rit-checkbox__indicator'>
                    <CheckBoxLeftIcon />
                </div>
            )
        };


        let labelThemeClass = '';
        if (labelTheme) {
            labelThemeClass = labelTheme;
        }

        const labelClassName = `b-rit-checkbox__label ${labelThemeClass}`;
        return (
            <label
                className={labelClassName}
                htmlFor={name}
            >
                <div className='b-rit-checkbox__row'>
                    {indicator}
                    <div className='b-rit-checkbox__title'>{label}</div>
                    {children}
                </div>
                <input
                    hidden
                    id={name}
                    className='b-rit-checkbox__real'
                    //value={this.state.checked}
                    checked={this.state.checked}
                    onChange={this.onCheck}
                    name={name}
                    type='checkbox'
                />
            </label>
        )
    }
};